import { SvgIcon, type SvgIconProps } from '@mui/material';

function EditorIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5C3 3.89543 3.89543 3 5 3H11V6L3 6V5ZM3 8H11V11H3V8ZM11 13H3V16H11V13ZM3 18H11V21H5C3.89543 21 3 20.1046 3 19V18ZM19 3H13V21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
      />
    </SvgIcon>
  );
}

export default EditorIcon;
